/**
 * Search type enum for document search
 * Matches backend: /backend/src/shared/enums/SearchTypeEnum.ts
 */
export enum SearchTypeEnum {
  DOCUMENT_NAME = 'name',
  PREFIX = 'prefix',
}

// Simple options for dropdown
export const SEARCH_TYPE_OPTIONS = [
  { value: SearchTypeEnum.DOCUMENT_NAME, label: 'Título' },
  { value: SearchTypeEnum.PREFIX, label: 'Prefixo' },
];

// Options compatible with FieldSearchBar (expects id and name)
export const SEARCH_TYPE_FIELD_OPTIONS = [
  { id: SearchTypeEnum.PREFIX, name: 'Prefixo' },
  { id: SearchTypeEnum.DOCUMENT_NAME, name: 'Título' },
];
